import { firefuncs } from "config/firebase";
import { httpsCallable } from "firebase/functions";

const sendConfirmationNeededText = (
  userId: string,
  gameName: string,
  expTime: string,
): Promise<any> => {
  const confirmationNeededText = httpsCallable(
    firefuncs,
    "sendConfirmationNeededText",
  );

  return confirmationNeededText({
    userId,
    gameName,
    expTime,
  });
};

interface PlayerTextData {
  receiverId: string;
  gameName: string;
  senderName: string;
}

const sendPlayerConfirmedText = (data: PlayerTextData): Promise<any> => {
  const { receiverId, gameName, senderName } = data;

  const confirmationText = httpsCallable(firefuncs, "sendPlayerConfirmedText");

  return confirmationText({
    hostId: receiverId,
    gameName,
    senderName,
  });
};

export default {
  sendConfirmationNeededText,
  sendPlayerConfirmedText,
};
